<template>
    <div>
        <transition name="fade">
            <div v-if="likes.length" class="post-tooltip">
                <div class="tooltiptext">
                    <ul class="list-unstyled mb-0">
                        <li class="small text-truncate" v-for="like in likeList">{{ like.employee.first_name }} {{ like.employee.last_name }}</li>
                        <li v-if="likesNotShownCount > 0" class="small">and {{ likesNotShownCount }} more...</li>
                    </ul>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

export default {
    props: {
        active: {
            type: Boolean,
            default: false
        },
        likes: {
            type: Array,
            default() {
                return [];
            }
        },
        user: {
            type: Object
        },
        bottomPosition: {
            type: String | Number,
            default: 'auto'
        },
        leftPosition: {
            type: Number,
            default: 0
        }
    },
    computed: {
        liked() {
            return this.likes.filter(like => like.employee_id === this.user.employee_id).length > 0;
        },
        likeList() {
            return this.likes.filter((like, index) => (index + 1) <= 10);
        },
        likesNotShownCount() {
            return this.likes.length - this.likeList.length;
        }
    }
}
</script>

<style lang="scss" scoped>
    .comment-box {
        padding: 0px 10px 10px 0px;
        line-height: 1.5em;
    }

    .comment-date {
        color: #666666;
    }

    .comment-text {
        font-size: 1.1rem;
    }

    .comment-actions {
        font-size: 1rem;
        width: 250px;

        p, a {
            line-height: 1;
        }
    }
</style>
